import { Collection } from 'modules/core/lib/mobx-rest'

import SupplementValidation from 'modules/payroll_bundle/store/models/SupplementValidation'

class SupplementValidations extends Collection<SupplementValidation> {
  get cacheKey(): string {
    return 'supplementValidations'
  }

  get indexes() {
    return ['author_id']
  }

  model() {
    return SupplementValidation
  }
}

const singleton: SupplementValidations = new SupplementValidations()

export default singleton
